import { serializeCacheEntry } from '../devtools/messages';
// TODO: Support delayed GC (5-10min timeout)
// TODO: Write updated states to indexeddb in a batch
export const createEntityCache = () => {
  const cache = new Map();
  return {
    get: (entity, instanceKey) => {
      var _cache$get;
      return (_cache$get = cache.get(entity.typeName)) === null || _cache$get === void 0 ? void 0 : _cache$get.get(instanceKey);
    },
    set: (entity, instanceKey, data) => {
      if (!cache.has(entity.typeName)) {
        cache.set(entity.typeName, new Map());
      }
      cache.get(entity.typeName).set(instanceKey, data);
    },
    __devtools: {
      getAllEntries: () => {
        const entries = {};
        for (const [typeName, instanceMap] of cache.entries()) {
          for (const [instanceKey, entry] of instanceMap.entries()) {
            entries[instanceKey] = {
              typeName,
              instanceKey,
              entry: serializeCacheEntry(entry)
            };
          }
        }
        return entries;
      },
      getSingleEntry: (typeName, instanceKey) => {
        var _cache$get2;
        const entry = (_cache$get2 = cache.get(typeName)) === null || _cache$get2 === void 0 ? void 0 : _cache$get2.get(instanceKey);
        if (!entry) {
          throw new Error(`Entry not found for type name: ${typeName} and instance key: ${instanceKey}`);
        }
        return {
          typeName,
          instanceKey,
          entry: serializeCacheEntry(entry)
        };
      }
    }
  };
};